import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getNames } from 'country-list';
import { notification } from 'antd';
import Navbar from '../Navbar';
import Foooter from '../Foooter';
import Footer from '../FooterMovil';
import api from "../../utils/apiClient";
import '../../style/Credito.css';
import styled from 'styled-components';
import PDFModal from '../ModalCredit';
import 'antd/dist/antd.css'; // Importa el CSS de antd
import { ReloadOutlined } from '@ant-design/icons';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';


// Estilos para el popup
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 16px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

const Popup = ({ message, onClose }) => (
  <Overlay>
    <ModalContainer>
      <CloseButton onClick={onClose}><strong>x</strong></CloseButton>
      <p>{message}</p>
    </ModalContainer>
  </Overlay>
);

const ButtonWithAuthCheck = ({ onSubmit, formData, setFormData }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showPDFModal, setShowPDFModal] = useState(false);

  const handleClick = () => {
    if (onSubmit()) {
      setShowPDFModal(true);
    } else {
      notification.error({
        message: 'Error',
        description: 'Por favor, completa todos los campos.',
        placement: 'top',
        style: {
          width: 400, // Ancho de la notificación
          fontSize: '16px', // Tamaño de la fuente
          padding: '20px', // Espacio interno
        },
      });
    }
  };

  const handleConfirm = async () => {
    setShowPDFModal(false);
    try {
      await api.post("solicitudes", formData);
      notification.success({
        message: 'Operación Exitosa',
        description: 'Formulario enviado exitosamente.',
        placement: 'top',
        style: {
          width: 400, // Ancho de la notificación
          fontSize: '16px', // Tamaño de la fuente
          padding: '20px', // Espacio interno
        },
      });
      // Limpiar formulario después del envío exitoso
      setFormData({
        nombre: '',
        apellido: '',
        direccion: '',
        fechaNacimiento: '',
        pais: '',
        compraDeseada: '',
        IDoRes: '',
        celular: '',
        correo: '',
        tipoVivienda: '',
        antiguedadLaboral: '',
        poseeVehiculo: false,
        ingresosMes: '',
        Status: 'Pendiente',
        tipo: "Credito",
        documentos: []
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Error al enviar el formulario.',
        placement: 'top',
        style: {
          width: 400, // Ancho de la notificación
          fontSize: '16px', // Tamaño de la fuente
          padding: '20px', // Espacio interno
        },
      });
    }
  };

  return (
    <>
      <button onClick={handleClick} className='credit-btn credit-btn-ghost credit-btn-lg'>
        Adjuntar comprobantes
      </button>
      {showPopup && (
        <Popup
          message="No puedes realizar esta acción si no estás logeado."
          onClose={() => setShowPopup(false)}
        />
      )}
      <PDFModal
        show={showPDFModal}
        onClose={() => setShowPDFModal(false)}
        onConfirm={handleConfirm}
        formData={formData}
        setFormData={setFormData}
      />
    </>
  );
};

const viviendaOptions = [
  { value: 'Propia', label: 'Propia' },
  { value: 'Alquilada', label: 'Alquilada' },
];

const antiguedadOptions = [
  { value: 'Menos de 6 meses', label: 'Menos de 6 meses' },
  { value: 'De 1 a 2 años', label: 'De 1 a 2 años' },
  { value: 'De 2 a 3 años', label: 'De 2 a 3 años' },
  { value: 'De 3 a 4 años', label: 'De 3 a 4 años' },
  { value: 'De 4 a 5 años', label: 'De 4 a 5 años' },
  { value: '+ 5 años', label: '+ 5 años' },
];

function Credito() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedVivienda, setSelectedVivienda] = useState(null);
  const [selectedAntiguedad, setSelectedAntiguedad] = useState(null);
  const [amount, setAmount] = useState('');
  const [months, setMonths] = useState('');
  const [interest, setInterest] = useState('');
  const [monthlyPayment, setMonthlyPayment] = useState(null);
  const [content, setContent] = useState('');
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    direccion: '',
    fechaNacimiento: '',
    pais: '',
    compraDeseada: '',
    IDoRes: '',
    celular: '',
    correo: '',
    tipoVivienda: '',
    antiguedadLaboral: '',
    poseeVehiculo: false,
    ingresosMes: '',
    Status: 'Pendiente',
    tipo: "Credito",
    documentos: []
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, celular: value });
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setFormData({ ...formData, pais: selectedOption.value });
  };

  const handleViviendaChange = (selectedOption) => {
    setSelectedVivienda(selectedOption);
    setFormData({ ...formData, tipoVivienda: selectedOption.value });
  };

  const handleAntiguedadChange = (selectedOption) => {
    setSelectedAntiguedad(selectedOption);
    setFormData({ ...formData, antiguedadLaboral: selectedOption.value });
  };

  const calculateMonthlyPayment = (months, amount, interest) => {
    const monthlyInterestRate = (interest / 100) / 12;
    const n = months;
    const P = amount;

    if (monthlyInterestRate === 0) {
      return P / n;
    }

    const monthlyPayment = (P * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, n)) /
                           (Math.pow(1 + monthlyInterestRate, n) - 1);

    return monthlyPayment;
  };

  const handleCalculate = () => {
    const payment = calculateMonthlyPayment(Number(months), Number(amount), Number(interest));
    setMonthlyPayment(payment.toFixed(2));
  };

  const handleReset = () => {
    setAmount('');
    setMonths('');
    setInterest('');
    setMonthlyPayment(null);
  };

  const fetchContent = async () => {
    try {
      const response = await api.get("content/content/Credito");
      setContent(response.data.body);
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  };

  const submit = () => {
    if (!formData.nombre || !formData.apellido || !formData.direccion || !formData.fechaNacimiento || !selectedOption || !formData.compraDeseada || !formData.IDoRes || !formData.celular || !formData.correo || !selectedVivienda || !selectedAntiguedad || !formData.ingresosMes) {
      notification.error({
        message: 'Error',
        description: 'Favor, completa todos los campos.',
        placement: 'top',
        style: {
          width: 400, // Ancho de la notificación
          fontSize: '16px', // Tamaño de la fuente
          padding: '20px', // Espacio interno
        },
      });
      return false;
    }

    return true; // Indica que los datos están completos y el formulario puede ser enviado
  };

  useEffect(() => {
    fetchContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const countries = getNames().map(country => ({ value: country, label: country }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '48px',
      height: '48px',
      backgroundColor: '#ffffff',
      borderColor: state.isFocused ? '#db3a34' : '#e4e8ec',
      borderRadius: '12px',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(219, 58, 52, 0.12)' : 'none',
      fontFamily: 'inherit',
      fontSize: '14px',
      cursor: 'pointer',
      '&:hover': {
        borderColor: state.isFocused ? '#db3a34' : '#d7dbe0',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 14px',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 12px 28px rgba(20, 25, 30, 0.12)',
      border: '1px solid #e4e8ec',
      overflow: 'hidden',
      zIndex: 20,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#db3a34' : state.isFocused ? '#f7f8fa' : '#ffffff',
      color: state.isSelected ? '#ffffff' : '#2f3b42',
      padding: '10px 14px',
      fontSize: '14px',
      cursor: 'pointer',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#2f3b42',
      fontSize: '14px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9aa3ab',
      fontSize: '14px',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? '#db3a34' : '#6c7781',
      padding: '6px 10px',
      '&:hover': { color: '#db3a34' },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  const handleFormSubmit = async () => {
    if (!submit()) {
      return;
    }

    try {
      await api.post("solicitudes", formData);
      notification.success({
        message: 'Operación Exitosa',
        description: 'Formulario enviado exitosamente.',
        placement: 'top',
        style: {
          width: 400,
          fontSize: '16px',
          padding: '20px',
        },
      });
      setFormData({
        nombre: '',
        apellido: '',
        direccion: '',
        fechaNacimiento: '',
        pais: '',
        compraDeseada: '',
        IDoRes: '',
        celular: '',
        correo: '',
        tipoVivienda: '',
        antiguedadLaboral: '',
        poseeVehiculo: false,
        ingresosMes: '',
        Status: 'Pendiente',
        tipo: "Credito",
        documentos: []
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Error al enviar el formulario.',
        placement: 'top',
        style: {
          width: 400,
          fontSize: '16px',
          padding: '20px',
        },
      });
    }
  };

  const formatCurrency = (val) => {
    if (val === null || isNaN(val)) return '';
    return Number(val).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleVehiculoToggle = (value) => {
    setFormData({ ...formData, poseeVehiculo: value });
  };

  return (
    <>
      <Navbar/>
      <div className='credit-page'>
        <div className='credit-page-inner'>
          <header className='credit-header'>
            <h1 className='credit-title'>Solicitud de Crédito</h1>
            <p className='credit-subtitle'>
              Calcula tu cuota mensual y envía tu solicitud en minutos.
            </p>
          </header>

          {content && (
            <div
              className="credit-content-body"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}

          <section className='credit-card'>
            <header className='credit-card-header'>
              <h2 className='credit-card-title'>Calcula tu cuota mensual</h2>
              <p className='credit-card-sub'>
                Estimación informativa — el monto final está sujeto a aprobación.
              </p>
            </header>

            <div className='credit-calc-grid'>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='calc-amount'>
                  Monto a financiar (L)
                </label>
                <input
                  id='calc-amount'
                  className='credit-input'
                  type='text'
                  inputMode='numeric'
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder='500,000'
                />
              </div>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='calc-months'>
                  Plazo (meses)
                </label>
                <input
                  id='calc-months'
                  className='credit-input'
                  type='text'
                  inputMode='numeric'
                  value={months}
                  onChange={(e) => setMonths(e.target.value)}
                  placeholder='60'
                />
              </div>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='calc-interest'>
                  Tasa anual (%)
                </label>
                <input
                  id='calc-interest'
                  className='credit-input'
                  type='text'
                  inputMode='decimal'
                  value={interest}
                  onChange={(e) => setInterest(e.target.value)}
                  placeholder='12'
                />
              </div>
            </div>

            <div className='credit-calc-actions'>
              <button
                type='button'
                className='credit-btn credit-btn-primary'
                onClick={handleCalculate}
              >
                Calcular
              </button>
              {monthlyPayment !== null && !isNaN(monthlyPayment) && (
                <button
                  type='button'
                  className='credit-btn credit-btn-ghost'
                  onClick={handleReset}
                >
                  <ReloadOutlined /> Reiniciar
                </button>
              )}
            </div>

            {monthlyPayment !== null && !isNaN(monthlyPayment) && (
              <div className='credit-calc-result'>
                <span className='credit-calc-result-label'>
                  Cuota mensual estimada
                </span>
                <span className='credit-calc-result-value'>
                  L. {formatCurrency(monthlyPayment)}
                </span>
              </div>
            )}
          </section>

          <section className='credit-card'>
            <header className='credit-card-header'>
              <h2 className='credit-card-title'>Tu solicitud</h2>
              <p className='credit-card-sub'>
                Completa todos los campos para enviar tu solicitud.
              </p>
            </header>

            <div className='credit-form-grid'>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='nombre'>Nombre</label>
                <input className='credit-input' id='nombre' name='nombre' value={formData.nombre} placeholder='Juan' onChange={handleInputChange}/>
              </div>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='apellido'>Apellido</label>
                <input className='credit-input' id='apellido' name='apellido' value={formData.apellido} onChange={handleInputChange} placeholder='Pérez'/>
              </div>

              <div className='credit-field'>
                <label className='credit-label' htmlFor='email'>Correo electrónico</label>
                <input className='credit-input' id='email' type='email' name='correo' value={formData.correo} onChange={handleInputChange} placeholder='juan@ejemplo.com'/>
              </div>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='id'># de identidad o residencia</label>
                <input className='credit-input' id='id' name='IDoRes' value={formData.IDoRes} onChange={handleInputChange} placeholder='0801-1990-12345'/>
              </div>

              <div className='credit-field'>
                <label className='credit-label' htmlFor='fecha_nac'>Fecha de nacimiento</label>
                <input className='credit-input' id='fecha_nac' type='date' name='fechaNacimiento' value={formData.fechaNacimiento} onChange={handleInputChange}/>
              </div>
              <div className='credit-field'>
                <label className='credit-label'>Celular</label>
                <div className='credit-phone-wrap'>
                  <PhoneInput
                    defaultCountry='hn'
                    value={formData.celular}
                    onChange={handlePhoneChange}
                  />
                </div>
              </div>

              <div className='credit-field'>
                <label className='credit-label' htmlFor='dropdown'>País</label>
                <Select
                  inputId='dropdown'
                  value={selectedOption}
                  onChange={handleCountryChange}
                  options={countries}
                  placeholder='Selecciona un país'
                  styles={customStyles}
                />
              </div>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='laboral'>Antigüedad laboral</label>
                <Select
                  inputId='laboral'
                  value={selectedAntiguedad}
                  onChange={handleAntiguedadChange}
                  options={antiguedadOptions}
                  placeholder='Selecciona antigüedad'
                  styles={customStyles}
                  isSearchable
                />
              </div>

              <div className='credit-field'>
                <label className='credit-label' htmlFor='vivienda_type'>Tipo de vivienda</label>
                <Select
                  inputId='vivienda_type'
                  value={selectedVivienda}
                  onChange={handleViviendaChange}
                  options={viviendaOptions}
                  placeholder='Selecciona tu tipo de vivienda'
                  styles={customStyles}
                />
              </div>
              <div className='credit-field'>
                <label className='credit-label' htmlFor='ingresos'>Ingresos mensuales (L)</label>
                <input className='credit-input' id='ingresos' name='ingresosMes' value={formData.ingresosMes} onChange={handleInputChange} placeholder='15,000' inputMode='numeric'/>
              </div>

              <div className='credit-field'>
                <label className='credit-label' htmlFor='info_credit'>¿Qué deseas comprar?</label>
                <input className='credit-input' id='info_credit' name='compraDeseada' value={formData.compraDeseada} onChange={handleInputChange} placeholder='Ej: Toyota Corolla 2015'/>
              </div>
              <div className='credit-field'>
                <label className='credit-label'>¿Posee vehículo?</label>
                <div className='credit-toggle-group' role='radiogroup' aria-label='Posee vehículo'>
                  <button
                    type='button'
                    className={`credit-toggle ${formData.poseeVehiculo === true ? 'is-active' : ''}`}
                    onClick={() => handleVehiculoToggle(true)}
                    role='radio'
                    aria-checked={formData.poseeVehiculo === true}
                  >
                    Sí
                  </button>
                  <button
                    type='button'
                    className={`credit-toggle ${formData.poseeVehiculo === false ? 'is-active' : ''}`}
                    onClick={() => handleVehiculoToggle(false)}
                    role='radio'
                    aria-checked={formData.poseeVehiculo === false}
                  >
                    No
                  </button>
                </div>
              </div>

              <div className='credit-field credit-field-full'>
                <label className='credit-label' htmlFor='direccion'>Dirección</label>
                <input className='credit-input' id='direccion' name='direccion' value={formData.direccion} onChange={handleInputChange} placeholder='Col. Centro, Casa #123, Tegucigalpa'/>
              </div>
            </div>

            <div className='credit-actions'>
              <ButtonWithAuthCheck onSubmit={submit} formData={formData} setFormData={setFormData} />
              <button
                className='credit-btn credit-btn-primary credit-btn-lg'
                onClick={handleFormSubmit}
              >
                Enviar solicitud
              </button>
            </div>
          </section>

          <p className='credit-disclosure'>
            Informamos a nuestros clientes en general que Honduautos tiene suscrito
            un contrato de servicios con Equifax, una Central de Riesgos Privada o
            buró de crédito, a la cual consultamos y reportamos la información
            relacionada con su crédito.
          </p>
        </div>
      </div>
      <div className='web-footer'>
        <Foooter/>
      </div>
      <div className="movil-footer">
        <Footer/>
      </div>
    </>
  );
}

export default Credito;
